import en from "./en";
import es from "./es";

export const languages = {
    en,
    es,
};
